/**
 * Expose swiper globally to be used in frontend stuff
 * 
 * Used for when needing to hotfix, or write custom
 * swiper carousels on the frontend
 * 
 */

import Swiper, { Autoplay, EffectFade, Navigation, Pagination, A11y} from 'swiper/core';
Swiper.use([Autoplay, EffectFade, Navigation, Pagination, A11y]);

window.Swiper = Swiper;

console.log("I am importing swiper");